import {
  computed,
  // eslint-disable-next-line no-unused-vars
  ComputedRef,
} from '@vue/composition-api';
// eslint-disable-next-line no-unused-vars
import { Store } from '@sejazipper/layer-api-client';

/**
 * @param {import('vue/types/vue').Vue} root
 */
export const useVuexSellerStores = (root) => {
  const customer = computed(() => root.$store.state.customer);

  const profile = computed(() => root.$store.state.profile);

  /**
   * @type {ComputedRef<Store[]>}
   */
  const stores = computed(() => {
    if (customer.value && customer.value.stores) {
      if (profile.value.director) {
        return customer.value.stores;
      }
      return customer.value.stores.filter(
        (store) => store.sellers.filter((seller) => seller.id === root.$auth.user.sub).length > 0,
      );
    }
    return null;
  });

  const loading = computed(() => !stores.value);

  return {
    stores,
    loading,
  };
};
